import React, { useState, useEffect } from 'react';
import { Row, Col, message } from 'antd';
import styled from 'styled-components/macro';
import { Switch, Route } from 'react-router-dom';

import Card from 'components/Card/Card';
import { createHost } from 'utils/apis/hostRegister';
import { buildHostRegistrationHostFormRoute, buildHostRegistrationPropertyFormRoute, buildHostRegistrationSuccessRoute } from 'utils/routes';

import HostRegistrationProgressIndicator from './components/HostRegistrationProgressIndicator/HostRegistrationProgressIndicator';
import HostRegistrationForm from './components/HostRegistrationForm/HostRegistrationForm';
import PropertyRegistration from './components/PropertyRegistration/PropertyRegistration';
import SuccessRegistration from './components/HostRegistrationSuccess/HostRegistrationSuccess';

import BackgroundSVG from '../Enquiry/images/bg.svg';

const hostRoute = buildHostRegistrationHostFormRoute();
const propertyRoute = buildHostRegistrationPropertyFormRoute();
const successRoute = buildHostRegistrationSuccessRoute();

const HostRegistrationContentsCard = styled(Card)`
  flex-direction: column;
  min-height: 850px;

  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

const HostRegistrationContents = ({ history, location }) => {
  const [hostInfo, setHostInfo] = useState({});
  const [propertyInfo, setProperties] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOnSaveRegisterForm = newHostInfo => {
    setHostInfo(newHostInfo);
    history.push(propertyRoute);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (hostInfo && Object.keys(hostInfo).length === 0 && location.pathname !== hostRoute) {
      history.replace(hostRoute);
    }
  }, [location.pathname, history, hostInfo]);

  const handleOnComplete = newProperties => {
    setIsSubmitting(true);

    const combinedValues = { ...hostInfo, buildings: newProperties };

    setProperties(newProperties);
    createHost(combinedValues)
      .then(() => {
        history.push(successRoute);
      })
      .catch(error => {
        message.error(error.message);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleOnBackPropertyForm = newProperties => {
    setProperties(newProperties);
    history.goBack();
  };

  const handleOnBack = () => {
    history.push('/');
  };

  return (
    <HostRegistrationContentsCard>
      <HostRegistrationProgressIndicator currentPath={location.pathname} />
      <Switch>
        <Route
          exact
          path={hostRoute}
          render={props => <HostRegistrationForm values={hostInfo} onSave={handleOnSaveRegisterForm} onBack={handleOnBack} />}
        />
        <Route
          exact
          path={propertyRoute}
          render={props => (
            <PropertyRegistration values={propertyInfo} onBack={handleOnBackPropertyForm} onSave={handleOnComplete} isNextLoading={isSubmitting} />
          )}
        />
        <Route exact path="/register/success" render={props => <SuccessRegistration onSuccess={handleOnBack} />} />
      </Switch>
    </HostRegistrationContentsCard>
  );
};

const HostRegistrationRow = styled(Row)`
  background-image: url(${BackgroundSVG});
  min-height: 100vh;
  background-size: cover;
  height: 100%;
`;


const HostRegistration = ({ history, location }) => (
  <HostRegistrationRow type="flex" justify="center" align="middle">
    <Col span={24} lg={22}>
      <HostRegistrationContents history={history} location={location} />
    </Col>
  </HostRegistrationRow>
);

export default HostRegistration;
